import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchProductsByCategory } from "../api/products";
import { ProductCard } from "../components/ProductCard";
import { Banner } from "../components/Banner";

export default function CategoryPage() {
  const { id } = useParams<{ id: string }>();

  const {
    data = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["productsByCategory", id],
    queryFn: () => fetchProductsByCategory(id!),
    enabled: !!id,
  });

  if (isLoading) return <div>Загрузка…</div>;
  if (error instanceof Error) return <div>Ошибка: {error.message}</div>;
  if (!data.length) return <div>В этой категории пока нет товаров</div>;

  return (
    <div>
      <Banner />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {data.map((p: any) => (
          <ProductCard
            key={p._id || p.id}
            _id={p.id || p._id}
            title={p.name || p.title}
            price={p.cost ?? p.price}
            image={p.image}
            size={p.size}
            extra={p.extra}
            taste={p.taste}
          />
        ))}
      </div>
    </div>
  );
}
